import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useMutation } from '@apollo/client'

import { CurrentLegalFormalityContext } from 'contexts/LegalFormalityContext'
import { EDIT_FORMALITY_FLOW_MUTATION } from 'graphql/LegalFormalities'
import FormalityStepButton from './FormalityStepButton'

const FormalityAbortBtn = () => {
  const { t } = useTranslation('legalFormalities')
  const { legalFormality, legalFormalityRefetch, setCurrentTab } = useContext(
    CurrentLegalFormalityContext
  )
  const status = legalFormality.status
  const isAborted = status === 'flow_aborted'
  const [abortFormality] = useMutation(EDIT_FORMALITY_FLOW_MUTATION)

  if (isAborted) {
    return <></>
  }

  const handleAbort = () => {
    abortFormality({
      variables: { id: legalFormality.id, abort: true },
    })
      .then(r => {
        setCurrentTab('form')
        legalFormalityRefetch()
      })
      .catch(e => {
        console.error(e)
      })
  }

  return (
    <FormalityStepButton
      title={t('show.form.submit.confirm.abort.title')}
      description={t('show.form.submit.confirm.abort.description')}
      buttonLabel={t('show.form.submit.confirm.abort.label')}
      onConfirm={handleAbort}
      danger={true}
    />
  )
}

export default FormalityAbortBtn
